'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navi = void 0;
var $ = require("jquery");
var Navi = /** @class */ (function () {
    function Navi() {
        $('#trigCloseSpNavi').click(function () {
            $('#bulletSpNavi').attr('data-open', 0);
        });
        $('#trigOpenSpNavi').click(function () {
            $('#bulletSpNavi').attr('data-open', 1);
        });
    }
    return Navi;
}());
exports.Navi = Navi;
exports.default = Navi;
